//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Link } from "react-router-dom";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useTenantControlGetHook";

const ServiceList = () => {
  let token = localStorage.getItem("token");

  const { data: availableServices, isLoading } = useGetHook({
    queryKey: [`availableServices-${token}`],
    url: APIS.AVAILABLE_SERVICE,
    params: {
      token,
    },
  });

  return (
    <div
      className={tw` shadow-lg  rounded-lg w-full px-3 py-2 bg-primary-light`}
    >
      <ul
        className={tw`grid grid-cols-3 justify-between items-center gap-x-6 gap-y-6 `}
      >
        {isLoading
          ? Array.from({ length: 10 }).map((_, index: number) => {
              return (
                <div
                  key={index}
                  className={tw`w-20 h-20 rounded-xl bg-primary-hover animate-pulse`}
                ></div>
              );
            })
          : availableServices?.map((item: any) => (
              <li
                key={item.id}
                className={tw`hover:bg-primary-hover rounded-md cursor-pointer`}
                role="menuitem"
                tabIndex={0}
                aria-label={item?.services?.display_name}
              >
                <Link
                  to={`/${item?.default ? "" : item?.services?.url}`}
                  className={tw`flex-col flex items-center w-fit py-2 px-3  justify-center `}
                >
                  <span className={tw`block w-10 h-10`}>
                    <img
                      src={item?.services?.logo}
                      alt=""
                      className={tw`w-full h-full object-contain`}
                    />
                  </span>
                  <span className={tw`text-sm whitespace-nowrap w-fit`}>
                    {item?.services?.display_name}
                  </span>
                </Link>
              </li>
            ))}
      </ul>
    </div>
  );
};

export default ServiceList;
